<div class="swiper-top" [class.d-none]="!isNavigationEnabled && !title">
  @if (title) {
    <h2 class="text-b2-s text-md-b2-m text-lg-h4-s title">
      {{ title }}
    </h2>
  }

  <div class="swiper-navigation" #swiperNavigation>
    <sd-icon [type]="iconTypes.ARROW_PREV" class="swiper-navigation-icon-prev"></sd-icon>
    <sd-icon [type]="iconTypes.ARROW_NEXT" class="swiper-navigation-icon-next"></sd-icon>
  </div>
</div>

<swiper-container init="false" #swiperContainer>
  @if (items.length > 0) {
    @if (swiperSlidesConfig$ | async; as swiperSlidesConfig) {
      @for (item of items; track item; let i = $index) {
        <swiper-slide
          [class.width-auto]="resultConfig.slidesPerView === 'auto'"
          [class.last-swiper-slide]="i === items.length - 1"
        >
          @if (item | async; as data) {
            <ng-container
              *ngTemplateOutlet="
                template;
                context: { item: data, index: i, classList: getSlideClasses(swiperSlidesConfig, i) }
              "
            ></ng-container>
          }
        </swiper-slide>
      }
    }
  } @else {
    <ng-content></ng-content>
  }
</swiper-container>
